<template>
  <van-row class="white-page-bg payment-cb">
    <van-col span="24">
      <info-message class="itserve-center place-content-center">
        <img
          src="@/assets/images/action_success.png"
          alt="success-action"
        /><br />
        {{ $t("pay.cardAdded") }}
      </info-message>
    </van-col>
  </van-row>
</template>

<script>
import InfoMessage from "@/components/content/InfoMessage";
export default {
  components: { InfoMessage },
  name: "Success",
  data() {
    return {};
  },

  created() {
    // Проверяем, пришли ли мы со страницы оплаты
    const fromPayment = localStorage.getItem("fromPayment");
    const accountParams = localStorage.getItem("paymentParams");

    if (fromPayment === "true" && accountParams) {
      // Обновляем список карт
      this.$store.dispatch("Payment/getCardsList").then(() => {
        try {
          // Парсим параметры для перехода на страницу оплаты
          const params = JSON.parse(accountParams);

          // Проверяем, есть ли карты
          if (this.$store.state.Payment.cards.length > 0) {
            // Устанавливаем токен последней добавленной карты
            const lastCard = this.$store.state.Payment.cards[0];
            this.$store.commit("Payment/SET_CARD_TOKEN", lastCard.card_token);

            // Сохраняем токен карты в localStorage для автоматической оплаты
            localStorage.setItem("autoPaymentCardToken", lastCard.card_token);
          }

          // В любом случае переходим на страницу оплаты
          this.$router.push({
            name: "EasyPayPayment",
            params: params,
          });
        } catch (e) {
          console.error("Error parsing payment params:", e);
          // Даже в случае ошибки переходим на страницу оплаты
          this.$router.push({
            name: "EasyPayPayment",
          });
        }

        // Очищаем localStorage
        localStorage.removeItem("fromPayment");
        localStorage.removeItem("paymentParams");
      });
    }
  },
};
</script>

<style scoped></style>
